import { Box, CircularProgress, Typography, TypographyProps } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'store/hooks';
import { selectAwaitingRoomJoin, selectLobbyMessage } from 'features/room/roomSlice';

type AwaitingRoomJoinProps = {
  typographyProps?: TypographyProps;
};

const AwaitingRoomJoin = ({ typographyProps }: AwaitingRoomJoinProps) => {
  const { t } = useTranslation('join');

  const awaitingRoomJoin = useAppSelector(selectAwaitingRoomJoin);
  const lobbyMessage = useAppSelector(selectLobbyMessage);

  const renderMessage = () => {
    if (awaitingRoomJoin === 'scale-server-boot') {
      return t('awaiting_server_boot');
    }

    if (awaitingRoomJoin === 'entry-access') {
      if (lobbyMessage) {
        // eslint-disable-next-line react/no-danger
        return <span dangerouslySetInnerHTML={{ __html: lobbyMessage }} />;
      }
      return t('awaiting_entry_access');
    }

    return t('awaiting_session_start');
  };

  return (
    <Box
      data-testid="awaiting-room-join"
      sx={{
        textAlign: 'center',
      }}
    >
      <Typography
        sx={{
          mb: 6,
        }}
        {...typographyProps}
      >
        {renderMessage()}
      </Typography>
      <CircularProgress />
    </Box>
  );
};

export default AwaitingRoomJoin;
